export default __webpack_public_path__ + "static/11-robot-d5bcbe3988478927ae2797faffa9c0b7.png";